import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import { proxy } from 'valtio';
import { valtioDevTools } from '@lib/utils/devTools';
import { AnnouncementOptions, AnnouncementsState } from './types';

export const announcementsState = proxy<AnnouncementsState>({
  announcements: {},
});

valtioDevTools(announcementsState, 'announcementsState');

class AnnouncementsModule extends AppModule {
  /**
   * Provides an api for the application to render Anvil Announcements.
   * Announcements will be displayed in the order they are invoked.
   * With the newest Announcements at the top.
   * @param announcement - The announcement options.
   */
  public showAnnouncement(announcement: AnnouncementOptions, key: string) {
    announcementsState.announcements = {
      ...announcementsState.announcements,
      [key]: announcement,
    };
  }

  public hideAnnouncement(key: string) {
    delete announcementsState.announcements[key];
  }
}

export default new AnnouncementsModule(
  appManager.events,
  appManager.logger('Announcements'),
);
